var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 12.174a.591.591 0 1 0 0-1.182.591.591 0 0 0 0 1.182M8 10.05a.444.444 0 0 1-.445-.444V4.273a.444.444 0 1 1 .889 0v5.333a.444.444 0 0 1-.445.444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.694.746a1.432 1.432 0 0 1 2.51.001l6.173 11.36a1.43 1.43 0 0 1-1.257 2.114H1.787a1.43 1.43 0 0 1-1.289-2.115zM1.28 12.531a.542.542 0 0 0 .498.801H14.12a.542.542 0 0 0 .476-.801L8.424 1.173a.542.542 0 0 0-.95 0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };